<app-layout>
  <p-toast />

  <div class="home-element">
    <header>
      <h2><i class="pi pi-ticket"></i> Tickets de seguimiento</h2>

      <div class="header-actions">
        <span class="view-selector">
          <button
            [class]="
              'view-selector-button border-primary text-primary ' +
              (activeView === 'kanban'
                ? 'view-selector-button-active bg-primary border-primary'
                : '')
            "
            (click)="toggleView('kanban')"
          >
            <i class="pi pi-th-large" style="font-size: 1rem"></i>
          </button>

          <button
            [class]="
              'view-selector-button border-primary text-primary ' +
              (activeView === 'table'
                ? 'view-selector-button-active bg-primary border-primary'
                : '')
            "
            (click)="toggleView('table')"
          >
            <i class="pi pi-table" style="font-size: 1rem"></i>
          </button>
        </span>

        <p-button
          (click)="isModalVisible = true"
          type="button"
          icon="pi pi-plus"
          styleClass="p-button-rounded"
        >
        </p-button>
      </div>
    </header>

    <div class="search-section">
      <p-iconField iconPosition="left">
        <p-inputIcon>
          <i class="pi pi-search"></i>
        </p-inputIcon>

        <input
          pInputText
          type="text"
          [value]="dataForm.value.search"
          (input)="onFilterInput($event, 'search')"
          placeholder="Buscar"
        />
      </p-iconField>

      <p-button
        (click)="resetFilters()"
        type="button"
        icon="pi pi-filter-slash"
        styleClass="p-button-rounded"
        severity="danger"
      >
      </p-button>
    </div>

    <p-accordion>
      <p-accordionTab header="Filtrar tickets">
        <section class="filters-section" [formGroup]="dataForm">
          <div class="filters-group">
            <span class="p-fluid p-float-label">
              <p-autoComplete
                label=""
                [dropdown]="true"
                [suggestions]="filteredStatuses"
                (completeMethod)="filterStatus($event)"
                field="name"
                formControlName="status"
                (onSelect)="selectField($event, 'status')"
                (onClear)="selectField(null, 'status')"
                appendTo="body"
                [forceSelection]="true"
                dataKey="id"
              >
              </p-autoComplete>

              <label for="autocomplete">Estatus</label>
            </span>

            <span class="p-fluid p-float-label">
              <p-autoComplete
                formControlName="ticket_type"
                [suggestions]="filteredTicketTypes"
                [showEmptyMessage]="true"
                appendTo="body"
                [dropdown]="true"
                field="name"
                [minLength]="1"
                (completeMethod)="filterTickets($event)"
                (onSelect)="selectField($event, 'ticket_type')"
                (onClear)="selectField(null, 'ticket_type')"
                [forceSelection]="true"
                dataKey="id"
              >
              </p-autoComplete>

              <label for="autocomplete">Tipo de ticket</label>
            </span>
          </div>
        </section>
      </p-accordionTab>
    </p-accordion>

    <ng-container *ngIf="activeView === 'table'; else kanban">
      <section class="table-container">
        <p-table
          #dt2
          [value]="tickets"
          dataKey="id"
          [rows]="dataForm.value.page_size"
          [rowsPerPageOptions]="[10, 20, 30, 50]"
          [loading]="loading"
          [paginator]="false"
          styleClass="p-datatable-sm"
          currentPageReportTemplate="{currentPage} de {totalPages}"
          [globalFilterFields]="['folio', 'close_date']"
        >
          <ng-template pTemplate="header">
            <tr>
              <th
                style="width: 10%"
                pSortableColumn="folio"
                class="bg-gray-100 border-bottom"
              >
                <p class="th-inside">
                  #Folio
                  <p-sortIcon field="folio" />
                </p>
              </th>

              <th
                style="width: 10%"
                pSortableColumn="status.name"
                class="bg-gray-100 border-bottom"
              >
                <p class="th-inside">
                  Estado
                  <p-sortIcon field="status.name" />
                </p>
              </th>

              <th
                style="width: 15%"
                pSortableColumn="ticket_type.name"
                class="bg-gray-100 border-bottom"
              >
                <p class="th-inside">
                  Tipo de ticket
                  <p-sortIcon field="ticket_type.name" />
                </p>
              </th>

              <th
                style="width: 15%"
                pSortableColumn="area_category.name"
                class="bg-gray-100 border-bottom"
              >
                <p class="th-inside">
                  Área
                  <p-sortIcon field="area_category.name" />
                </p>
              </th>

              <th
                style="width: 15%"
                pSortableColumn="plague_category"
                class="bg-gray-100 border-bottom"
              >
                <p class="th-inside">Plagas</p>
              </th>

              <th
                style="width: 10%"
                pSortableColumn="close_date"
                class="bg-gray-100 border-bottom"
              >
                <p class="th-inside">
                  Fecha
                  <p-sortIcon field="close_date" />
                </p>
              </th>

              <th
                style="width: 25%"
                pSortableColumn="comments"
                class="bg-gray-100 border-bottom"
              >
                <p class="th-inside">
                  Comentarios
                  <p-sortIcon field="comments" />
                </p>
              </th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-ticket>
            <tr class="text-sm">
              <td>
                <span class="folio">
                  {{ ticket.folio }}
                </span>
              </td>

              <td>
                <p-dropdown
                  [options]="statuses"
                  [(ngModel)]="ticket.status"
                  optionLabel="name"
                  (onChange)="updateTicketStatus(ticket, $event.value.id)"
                  appendTo="body"
                  [style]="{ 'min-width': '150px' }"
                >
                  <ng-template pTemplate="selectedItem">
                    <span [class]="getStatusClass(ticket.status)">
                      {{ ticket.status.name }}
                    </span>
                  </ng-template>
                </p-dropdown>
              </td>

              <td>
                {{ ticket.ticket_type?.name }}
              </td>

              <td>
                {{ ticket.area_category?.name || "-" }}
              </td>

              <td>
                <span
                  *ngFor="let plague of ticket.plague_category; let last = last"
                >
                  {{ plague.name }}<span *ngIf="!last">, </span>
                </span>
                <span
                  *ngIf="
                    !ticket.plague_category ||
                    ticket.plague_category.length === 0
                  "
                  >-</span
                >
              </td>

              <td>
                {{ ticket.close_date | date: "dd/MM/yyyy" }}
              </td>

              <td class="table-text">
                {{ ticket.comments }}
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="7">
                <p class="emptymessage">No se encontraron tickets</p>
              </td>
            </tr>
          </ng-template>
        </p-table>

        <p-paginator
          [first]="dataForm.value.firstPage"
          [rows]="dataForm.value.page_size"
          [rowsPerPageOptions]="[10, 20, 30, 50]"
          [totalRecords]="dataForm.value.totalRecords"
          (onPageChange)="pageChange($event)"
          currentPageReportTemplate="{currentPage} de {totalPages}"
          [showJumpToPageDropdown]="true"
          [showPageLinks]="true"
          [showJumpToPageInput]="true"
        ></p-paginator>
      </section>
    </ng-container>

    <ng-template #kanban>
      <div class="kanban-container">
        <div
          *ngFor="let column of kanbanColumns"
          class="kanban-list"
          [class.drag-over]="dragOverColumnId === column.statusId"
          (drop)="onDrop($event, column.statusId)"
          (dragover)="onDragOver($event, column.statusId)"
          (dragleave)="onDragLeave($event)"
        >
          <div
            class="list-header"
            [style]="{ 'border-top-color': column.color }"
          >
            <h3>{{ column.title }}</h3>
            <p><strong>Número de tickets: </strong>{{ column.total || 0 }}</p>
          </div>

          <section class="kanban-cards">
            <article
              *ngFor="let ticket of column.tickets"
              class="kanban-card"
              draggable="true"
              (dragstart)="onDragStart($event, ticket)"
              (dragend)="onDragEnd($event)"
            >
              <header>
                <div class="kanban-card-folio">
                  <h4 class="kanban-card-title">{{ ticket.folio }}</h4>
                  <p class="kanban-card-date">
                    {{ ticket.close_date | date: "dd/MM/yyyy" }}
                  </p>
                </div>
              </header>

              <main>
                <p><strong>Tipo:</strong> {{ ticket.ticket_type?.name }}</p>
                <p class="ticket-comments">
                  <strong>Comentarios:</strong> {{ ticket.comments }}
                </p>
              </main>

              <footer>
                <span [class]="getStatusClass(ticket.status)">
                  {{ ticket.status.name }}
                </span>
              </footer>
            </article>

            <div *ngIf="column.loading" class="kanban-loading">
              <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
            </div>
          </section>

          <div
            *ngIf="column.currentPage < column.totalPages"
            class="kanban-load-more"
          >
            <button
              type="button"
              (click)="loadMoreKanbanItems(column)"
              [disabled]="column.loading"
            >
              <i class="pi pi-angle-down"></i>
              Cargar más
            </button>
          </div>
        </div>
      </div>
    </ng-template>

    <p-dialog
      [modal]="true"
      [(visible)]="isModalVisible"
      [style]="{ width: '50%', 'min-width': '30rem' }"
    >
      <ng-template pTemplate="header">
        <div class="dialog-header">
          <span class="dialog-header-title">
            <i class="pi pi-ticket"></i> Agregar nuevo ticket
          </span>
        </div>
      </ng-template>

      <form
        [formGroup]="tracingForm"
        novalidate
        (submit)="handleSave($event)"
        class="form"
      >
        <div class="form-group mt-4 mb-4">
          <span class="w-100 p-fluid p-float-label">
            <p-autoComplete
              formControlName="ticketType"
              [suggestions]="filteredTicketTypes"
              [showEmptyMessage]="true"
              appendTo="body"
              [dropdown]="true"
              field="name"
              [minLength]="1"
              (completeMethod)="filterTickets($event)"
              class="w-full"
            >
            </p-autoComplete>

            <label for="autocomplete"> Tipo de ticket </label>
          </span>

          <span class="p-fluid p-float-label">
            <p-autoComplete
              formControlName="media"
              [suggestions]="mediaOptions"
              [showEmptyMessage]="true"
              appendTo="body"
              [dropdown]="true"
              field="name"
              [minLength]="1"
              (completeMethod)="filterMedia($event)"
              class="w-full"
            >
            </p-autoComplete>

            <label for="autocomplete"> Medio </label>
          </span>
        </div>

        <div class="form-group mt-4 mb-4">
          <span class="p-fluid p-float-label">
            <p-autoComplete
              formControlName="nestingArea"
              [suggestions]="nestingAreas"
              [showEmptyMessage]="true"
              appendTo="body"
              [dropdown]="true"
              field="name"
              [minLength]="1"
              (completeMethod)="filterNestingArea($event)"
              class="w-full"
              [multiple]="true"
            >
            </p-autoComplete>

            <label for="autocomplete"> Nesting area </label>
          </span>

          <span class="p-fluid p-float-label">
            <p-autoComplete
              formControlName="plagueCategory"
              [suggestions]="plagueCategories"
              [showEmptyMessage]="true"
              appendTo="body"
              [dropdown]="true"
              field="name"
              [minLength]="1"
              (completeMethod)="filterPlagueCategory($event)"
              class="w-full"
              [multiple]="true"
            >
            </p-autoComplete>

            <label for="autocomplete"> Categoría de plaga </label>
          </span>
        </div>

        <div class="form-group mt-4 mb-4 form-group--full">
          <span class="p-fluid p-float-label">
            <p-autoComplete
              formControlName="plague"
              [suggestions]="plagues"
              [showEmptyMessage]="true"
              appendTo="body"
              [dropdown]="true"
              field="name"
              [minLength]="1"
              (completeMethod)="filterPlague($event)"
              class="w-full"
              [multiple]="true"
            >
            </p-autoComplete>

            <label for="autocomplete"> Plaga </label>
          </span>
        </div>

        <div class="w-full mt-4 mb-4">
          <textarea
            rows="3"
            pInputTextarea
            placeholder="Comentarios"
            formControlName="comments"
            class="w-full"
          >
          </textarea>
        </div>

        <div class="button-group mt-4">
          <button
            pButton
            pRipple
            type="submit"
            [disabled]="tracingForm.invalid"
            label="Guardar"
            class="p-button-raised"
            size="small"
          ></button>

          <button
            (click)="isModalVisible = false"
            pButton
            pRipple
            type="button"
            label="Cancelar"
            class="p-button-raised p-button-secondary"
            size="small"
          ></button>
        </div>
      </form>
    </p-dialog>
  </div>
</app-layout>
